// Packages
import { Component } from "react";
import { Link, withRouter } from "react-router-dom";
// Views
import SchoolAdminDashboard from "./schoolAdminDashboard";
// Assets
import videoCamera from "../../assets/images/videoCamera.svg";
// Services
import userService from "../../services/user.service";
import { getFromLocalStorage } from "../../utils/webStorage";
import { connect } from "react-redux";
import { userRoles } from "../../utils/constant";
import PageNotFoundPage from "../../Common/PageNotFoundPage";
import { FaRegClock } from "react-icons/fa";
import {
  openConfirmationPopup,
  openFailDialog,
  openSuccessPopup,
} from "../../Redux/Actions/PopupActions";
import { CircularProgress } from "@material-ui/core";
import GameCard from "../../Common/GameCard";
import FeedContainer from "./Feed/FeedContainer";

class schoolAdminFeed extends Component {
  constructor(props) {
    super(props);
    this.schoolId = getFromLocalStorage("schoolId");
    this.schoolName = getFromLocalStorage("schoolName");
    this.schoolLogo = getFromLocalStorage("schoolLogo");
    this.userId = getFromLocalStorage("currentUserId");
    this.userRole = this.props.userRole;
    this.state = {
      anchorEl: null,
      recentGameDashboardResponses: [],
      upcommingGameDashboardResponses: [],
      liveEventData: [],
      liveGameDashboardResponsesFlag: true,
      recentGameDashboardResponsesFlag: true,
      upcommingGameDashboardResponsesFlag: true,
      isPaymentOverdue: false,
      billingMsg: "",
      assignedRights: [],
      gamesLoading: false,
    };
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  componentDidMount() {
    const assignedRights = this.props.permissionRights;
    const assignedRightsIds = assignedRights.map((item) => item.displayName);
    this.setState({
      assignedRights: assignedRightsIds,
    });
    this.getSchoolFeed();
    this.checkPaymentStatus();

    this.getLiveEventAPIcall();
  }

  checkPaymentStatus() {
    const { schoolId } = this;
    userService.getBillingDetailsCheck(schoolId).then((res) => {
      const check = res.data.status;
      this.setState({ isPaymentOverdue: check });
      if (res.data.data != null) {
        this.setState({ billingMsg: res.data.data.split(",") });
      }
    });
  }

  getLiveEventAPIcall() {
    const { schoolId } = this;
    userService
      .getLiveEventDropdown(schoolId)
      .then((response) => {
        const liveEventData = response.data.data;
        this.setState({ liveEventData });
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  getSchoolFeed() {
    const { schoolId } = this;
    this.setState({ gamesLoading: true });
    userService
      .getSchoolAdminDashboardData(schoolId)
      .then((response) => {
        const liveGameDashboardResponses =
          response.data.data.liveGameDashboardResponses;
        const recentGameDashboardResponses =
          response.data.data.recentGameDashboardResponses;
        //recentGameDashboardResponses
        //Here eventDate is date for an event created on season page
        //So we have extracted recent games such that the game should less than eventDate
        //and should be sort using createdAt field of games
        //games means video we are uplaoding in batch by selected week:opponent and event then playlist
        recentGameDashboardResponses.sort(
          (a, b) => new Date(b.eventDate) - new Date(a.eventDate)
        );
        const upcommingGameDashboardResponses =
          response.data.data.upcommingGameDashboardResponses;
        const liveGameDashboardResponsesFlag =
          liveGameDashboardResponses.length !== 0;
        const recentGameDashboardResponsesFlag =
          recentGameDashboardResponses.length !== 0;
        const upcommingGameDashboardResponsesFlag =
          upcommingGameDashboardResponses.length !== 0;
        this.setState({
          recentGameDashboardResponses,
          upcommingGameDashboardResponses,
          liveGameDashboardResponses,
          liveGameDashboardResponsesFlag,
          recentGameDashboardResponsesFlag,
          upcommingGameDashboardResponsesFlag,
          gamesLoading: false,
        });
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  dismissWarning = () => {
    this.setState({ isPaymentOverdue: false });
  };

  render() {
    const {
      isPaymentOverdue,
      anchorEl,
      recentGameDashboardResponses,
      upcommingGameDashboardResponses,
      liveGameDashboardResponses,
      submitting,
      billingMsg,
      assignedRights,
      gamesLoading,
    } = this.state;
    const { userRole } = this;
    const { isDrawerOpen } = this.props;
    return (
      <div className={submitting ? "gray-out" : " "}>
        {userRole !== userRoles.ROLE_SCHOOL_ADMIN ? (
          <div>
            <SchoolAdminDashboard />
            <div
              // className="content-layout"
              className={
                isDrawerOpen ? "content-layout" : "toggle-content-layout p-2"
              }
            >
              {isPaymentOverdue && (
                <div className="mobile-warning-main">
                  <div className="mobile-warningg">
                    <p className="fs-16 medium text-light">{billingMsg[0]}</p>
                    <div
                      className="warning-btn-div"
                      style={{ display: "flex" }}
                    >
                      <Link to="/billingDetails" className="v-details">
                        View Details
                      </Link>
                      <button
                        className="dismiss-btn"
                        onClick={() => this.dismissWarning()}
                      >
                        Dismiss
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <div className="row mt-0">
                <div className="col-12 col-sm-12 col-md-8 col-lg-8  plpr-0">
                  {/* {(userRole == userRoles.ROLE_SCHOOL_ADMIN ||
                    assignedRights.includes("Add / Remove Video Content")) && (
                    <div
                      className="col-12 col-sm-12 col-md-12 col-lg-12 card-box"
                      id="deskSection"
                    >
                      <div className="row">
                        <div className="clear20 col-md-12"></div>
                        <div className="col-lg-4 col-md-6 col-12 col-sm-12 pl-4">
                          <Link to="/uploadvideo">
                            <div
                              className="card-box-style cp"
                              aria-owns={anchorEl ? "simple-menu" : null}
                              aria-haspopup="true"
                              onClick={this.handleClick}
                            >
                              <img src={videoCamera} alt="Video" />
                              <span className="fs-16 semi-bold vcenter black">
                                {" "}
                                Upload Video
                              </span>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>
                  )} */}
                  {/* mobile responsive code */}
                  {/* {(userRole == userRoles.ROLE_SCHOOL_ADMIN ||
                    assignedRights.includes("Add / Remove Video Content")) && (
                    <div id="mobileUpload">
                      <div className="row">
                        <div className="col-6 col-sm-4 border-right">
                          <div className="card-box-mobile">
                            <img
                              src={videoCamera}
                              alt="Video"
                              className="wh-29"
                            />
                            <p className="pt-2 fs-13 semi-bold">Upload Video</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )} */}

                  {/* end mobile responsive */}
                  {/* <div className="clear20"></div> */}
                  <FeedContainer />
                </div>
                <div className="col-4 col-sm-4 col-md-4 col-lg-4 position-relative">
                  {gamesLoading ? (
                    <div className="d-flex justify-content-center mg-top-20">
                      <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
                        <CircularProgress
                          className="rounded-circle"
                          color="success"
                          sx={{ fontSize: 10, color: "#002244" }}
                          disableShrink
                        />
                      </div>
                    </div>
                  ) : (
                    <>
                      <GameCard
                        gameList={liveGameDashboardResponses}
                        title="Live Games"
                        icon={<FaRegClock className="fs-20 text-danger" />}
                      />
                      <GameCard
                        gameList={upcommingGameDashboardResponses}
                        title="Upcoming Games"
                        icon={<FaRegClock className="fs-20 green" />}
                      />
                      <GameCard
                        gameList={recentGameDashboardResponses}
                        title="Recent Games"
                        icon={<FaRegClock className="fs-20 text-warning" />}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <PageNotFoundPage />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setConfirmationPopupInformation: (obj) =>
      openConfirmationPopup(dispatch, obj),
    setSuccessPopupInformation: (obj) => openSuccessPopup(dispatch, obj),
    setFailPopUpInformation: (obj) => openFailDialog(dispatch, obj),
  };
};

const mapStateToProps = (state) => {
  return {
    userRole: state.loggedInUser.role,
    permissionRights: state.loggedInUser.userProfile.permissionRights,
    isDrawerOpen: state?.schoolAdminDashboardInformation.isDrawerOpen,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(schoolAdminFeed)
);
